import * as React from 'react';
import RcCollapse from 'rc-collapse';
import { ConfigContext } from '../config-provider';
const CollapsePanel = props => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className = '' } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    return <RcCollapse.Panel {...props} prefixCls={prefixCls} className={className}/>;
};
export default CollapsePanel;
